import { useParams } from 'react-router-dom';
import { ActivitiesTab } from './ActivitiesTab';
import { HistoryTab } from './HistoryTab';
import {
  type OverlayPageProps,
  OverlayPageProvider,
} from './OverlayPageContext';
import { OverlayPageSidebar } from './OverlayPageSidebar';
import { OverviewTab } from './OverviewTab';
import { PresentationsTab } from './PresentationsTab';
import { SpeakerNotesTab } from './SpeakerNotesTab';
import type { OverlayPageTab } from './types';

const componentByTabId = {
  overview: <OverviewTab />,
  presentations: <PresentationsTab />,
  activity: <ActivitiesTab />,
  history: <HistoryTab />,
  'speaker-notes': <SpeakerNotesTab />,
};

export const OverlayPage = (props: OverlayPageProps) => {
  const { tabId } = useParams<{ tabId: OverlayPageTab }>();

  return (
    <OverlayPageProvider {...props}>
      <div className="flex h-full w-full">
        <OverlayPageSidebar />
        <div className="grow shrink-0">{tabId && componentByTabId[tabId]}</div>
      </div>
    </OverlayPageProvider>
  );
};
